import { useQuery } from '@tanstack/react-query';
import { getZoneLastUpdatedMetaPromise } from 'src/utils/api/get-zone-last-updated-meta';
import { useSearch } from 'src/hooks/use-search';
import { QUERY_KEY_MAP } from 'src/constants';

export const useGetZoneLastUpdatedMeta = () => {
  const [searchParams] = useSearch();
  const deviceId = searchParams?.device?.id || '';

  const { data, isLoading, error } = useQuery({
    queryKey: [QUERY_KEY_MAP.useGetZoneLastUpdatedMeta, deviceId],
    queryFn: () => getZoneLastUpdatedMetaPromise(deviceId),
    enabled: !!deviceId,
  });

  return {
    data,
    isLoading,
    error,
  };
};
